module.exports = __webpack_public_path__ + "img/base_model3.d0ca3bd8.jpg";